import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GlobalService } from '../_services/global.service';

@Component({
  selector: 'app-candidate-quick-view-contact',
  templateUrl: './candidate-quick-view-contact.component.html',
  styleUrls: ['./candidate-quick-view-contact.component.scss']
})

export class CandidateQuickViewContactComponent implements OnInit {

  @Input() candidateInfo
  @Input() currrentIndex
  contactDetails: any;
  canShowIcon: any;
  @Output() openSlider: EventEmitter<any> = new EventEmitter();
  @Output() hideContactText: EventEmitter<any> = new EventEmitter()

  phones: any[] = []
  canShowPhone: boolean = true;

  work_email: any[] = []
  canShowWork_email: boolean = true

  personal_email: any[] = []
  canShowPersonal_email: boolean = true

  totalContactsCount: number = 0;

  hideRevealContact: boolean = false;



  isViewMoreClicked: boolean = false;
  previewAndOldDetails: boolean = false;

  constructor() { }

  ngOnInit() {
    this.segregateContactWithProviders();

    if(this.candidateInfo && this.candidateInfo.contactDetails && this.candidateInfo.contactDetails.pdl){
      if(this.candidateInfo.contactDetails.pdl.personal_email || this.candidateInfo.contactDetails.pdl.phone || this.candidateInfo.contactDetails.pdl.work_email){
        this.hideContactText.emit(false)
      }
      
    }
    
    
  }


  segregateContactWithProviders(){

    if(this.candidateInfo){
      let work_email_existing 
      let personal_email_existing
      let phones_existing
      if(this.candidateInfo.existingContactDetails){
         work_email_existing = this.candidateInfo.existingContactDetails.filter(x => x.contactdetailcategory == "professional")
         personal_email_existing  = this.candidateInfo.existingContactDetails.filter(x => x.contactdetailcategory == "personal")
         phones_existing  = this.candidateInfo.existingContactDetails.filter(x => x.contactdetailcategory == null)
      }


      // if(this.candidateInfo.contactDetails && this.candidateInfo.contactDetails.pdl){
      //   if((this.candidateInfo.contactDetails.pdl.phone == false && 
      //     this.candidateInfo.contactDetails.pdl.work_email == false && 
      //     this.candidateInfo.contactDetails.pdl.personal_email == false) ||
      //     (work_email_existing && work_email_existing.length &&
      //     personal_email_existing && personal_email_existing.length &&
      //     phones_existing && phones_existing.length)
      //     ){
      //       console.log('dewdewdede')
      //       this.previewAndOldDetails = true
      //   }else{
      //     this.previewAndOldDetails = false
      //   }
      // }



        if((work_email_existing && work_email_existing.length ||
          personal_email_existing && personal_email_existing.length ||
          phones_existing && phones_existing.length)
          ){
            this.previewAndOldDetails = true
        }else{
          this.previewAndOldDetails = false
        }


    }

   
    if(this.candidateInfo && this.candidateInfo.existingContactDetails){
      this.work_email = this.candidateInfo.existingContactDetails.filter(x => (x?.type == 'email' &&  x.contactdetailcategory == "professional"))
      this.personal_email = this.candidateInfo.existingContactDetails.filter(x =>(x?.type == 'email' && x.contactdetailcategory == "personal"))
      this.phones = this.candidateInfo.existingContactDetails.filter(x => x?.type == 'contactnumber')


      if(this.work_email && this.work_email.length >= 2){
        this.totalContactsCount =  this.totalContactsCount + this.work_email.length - 1
      }

      if(this.personal_email && this.personal_email.length >= 2){
        this.totalContactsCount =  this.totalContactsCount + this.personal_email.length - 1
      }
      
      if(this.phones && this.phones.length >= 2){
        this.totalContactsCount =  this.totalContactsCount + this.phones.length - 1
        
      }
      
      if((this.work_email && this.work_email.length) || (this.personal_email && this.personal_email.length) || (this.phones && this.phones.length) ){
              this.hideRevealContact = true;
      }
      
    
      if(this.phones && this.phones.length){
        this.canShowPhone = true;
      }else{
        this.canShowPhone = false;
      }

      if(this.personal_email && this.personal_email.length){
        this.canShowPersonal_email = true
      }else{
        this.canShowPersonal_email = false
      }

      if(this.work_email && this.work_email.length){
        this.canShowWork_email = true;
      }else{
        this.canShowWork_email = false;
      }
    }else{
      if(this.candidateInfo && this.candidateInfo.contactDetails && this.candidateInfo.contactDetails.pdl){
        if(this.candidateInfo.contactDetails.pdl.phone == true){
          this.canShowPhone = true;
        }else{
          this.canShowPhone = false
        }

        if(this.candidateInfo.contactDetails.pdl.work_email == true){
          this.canShowWork_email = true;
        }else{
          this.canShowWork_email = false
        }

        if(this.candidateInfo.contactDetails.pdl.personal_email == true){
          this.canShowPersonal_email = true;
        }else{
          this.canShowPersonal_email = false
        }
      }
    }

    




  

    

  
  

   

  }




  openContact(){

    this.openSlider.emit({currrentIndex: this.currrentIndex })

  }

  viewmoredetails(data,type) {
    var moreElementId = "contact_more_" + this.currrentIndex;
    var lessElementId = "contact_less_" + this.currrentIndex;

    if (type == 'viewmore') {
      
      this.isViewMoreClicked = true;
      var moreElement :any = document.querySelectorAll('[id="' + moreElementId + '"]');

        for (var i = 0; i < moreElement.length; i++) {
          moreElement[i].style.display = 'block';
        }

        var lessElement: any = document.querySelectorAll('[id="' + lessElementId + '"]');

        for (var i = 0; i < lessElement.length; i++) {
          lessElement[i].style.display = 'none';
        }
    } else {

      this.isViewMoreClicked = false;
      var moreElement :any = document.querySelectorAll('[id="' + moreElementId + '"]');

        for (var i = 0; i < moreElement.length; i++) {
          moreElement[i].style.display = 'none';
        }

        var lessElement: any = document.querySelectorAll('[id="' + lessElementId + '"]');

        for (var i = 0; i < lessElement.length; i++) {
          lessElement[i].style.display = 'block';
        }

     
    }
  }

  //Trucate the string from middle
 truncateString(str){
    return GlobalService.truncateFromMiddle(str);
 }

}
